import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Resets scroll to the top on every client-side route change, with two
// exceptions:
//   - hash links (#anchor): the browser's native jump is preserved
//   - browser back/forward (POP): the browser's automatic scroll restoration
//     handles repositioning, so we stay out of its way
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (hash) return;
    if (navType === "POP") return;
    window.scrollTo(0, 0);
  }, [pathname, hash, navType]);

  return null;
}
